
import type { BaseFilter } from '~/type/Filter';
const __sfc_main = {};
__sfc_main.props = {
  list: {
    key: "list",
    required: true,
    type: Array
  },
  value: {
    key: "value",
    required: false,
    type: null
  },
  padding: {
    key: "padding",
    required: true,
    type: String
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const props = __props;

  /**
   * Второй компонент фильтров, который появляется в мобильной версии
   */

  const emit = __ctx.emit;
  function onClick(el?: BaseFilter) {
    if (el && el !== props.value) {
      /**
      * Срабатывавает при нажатии на фильтр
      */
      emit('change', el);
    } else {
      emit('change', ({} as BaseFilter));
    }
  }
  return {
    onClick
  };
};
export default __sfc_main;
